import { render, staticRenderFns } from "./FileListItemSkeleton.vue?vue&type=template&id=47b15fcd&scoped=true&"
import script from "./FileListItemSkeleton.vue?vue&type=script&lang=js&"
export * from "./FileListItemSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./FileListItemSkeleton.vue?vue&type=style&index=0&id=47b15fcd&scoped=true&lang=css&"
import style1 from "./FileListItemSkeleton.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b15fcd",
  null
  
)

export default component.exports